import { render, staticRenderFns } from "./AdminLeadsByStatusImplemented.vue?vue&type=template&id=2a147e14&scoped=true&"
import script from "./AdminLeadsByStatusImplemented.vue?vue&type=script&lang=js&"
export * from "./AdminLeadsByStatusImplemented.vue?vue&type=script&lang=js&"
import style0 from "./AdminLeadsByStatusImplemented.vue?vue&type=style&index=0&id=2a147e14&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a147e14",
  null
  
)

export default component.exports